"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Constants = exports.KEY_DELETE = exports.KEY_DOWN = exports.KEY_UP = exports.KEY_SPACE = exports.KEY_ESCAPE = exports.KEY_ENTER = exports.KEY_TAB = void 0;
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.
/**
 * @deprecated Use Constants.keys.tab instead.
 */
exports.KEY_TAB = 9;
/**
 * @deprecated Use Constants.keys.enter instead.
 */
exports.KEY_ENTER = 13;
/**
 * @deprecated Use Constants.keys.escape instead.
 */
exports.KEY_ESCAPE = 27;
/**
 * @deprecated Use Constants.keys.space instead.
 */
exports.KEY_SPACE = 32;
/**
 * @deprecated Use Constants.keys.up instead.
 */
exports.KEY_UP = 38;
/**
 * @deprecated Use Constants.keys.down instead.
 */
exports.KEY_DOWN = 40;
/**
 * @deprecated Use Constants.keys.delete instead.
 */
exports.KEY_DELETE = 46;
var Constants = /** @class */ (function () {
    function Constants() {
    }
    Constants.keys = {
        tab: "Tab",
        enter: "Enter",
        escape: "Escape",
        space: " ",
        up: "ArrowUp",
        down: "ArrowDown",
        delete: "Delete",
        backspace: "Backspace",
        left: "ArrowLeft",
        right: "ArrowRight"
    };
    return Constants;
}());
exports.Constants = Constants;
//# sourceMappingURL=constants.js.map